import { useEffect, useState, useRef } from 'react';

// Hooks
import useVisible from '../../hooks/visible'

// Functions
import pxToRem from '../../functions/px-to-rem'

const MessengerDom = ({ messages, styles, onRemoveMessage: removeMessage }) => {
	const [stylesFetched, setStylesFetched] = useState(false);

	useEffect(() => {
		styles().then(() => {
			setStylesFetched(true);
		})
	}, [styles])

	if(stylesFetched) {
		return (
			<div className={'messenger-container' + (messages.length === 0 ? ' empty' : '')}>
				{messages.map((message, nth) => (
					<Message
						message={message}
						nth={nth}
						onHidden={() => { removeMessage(nth)}}
						key={message.id} />
				))}
			</div>
		)
	}
}

const Message = ({ message, onHidden, nth }) => {
	const [hide, setHide] = useState(false);
	const [inDom, visible] = useVisible(!hide, 600, true);

	const domElem = useRef();
	const hideMargin = useRef('-5rem');
	const _mounted = useRef(false);

	const hideElem = () => {
		setHide(true);
	}

	useEffect(() => {
		_mounted.current = true;
		hideMargin.current = `-${pxToRem(domElem.current.offsetHeight)}rem`;

		setTimeout(() => {
			if(_mounted.current) {
				hideElem()
			}
		}, 4000)

		return () => {
			_mounted.current = false;
		}
	}, [])

	useEffect(() => {
		if(!inDom && hide) {
			onHidden(nth);
		}
	}, [inDom, hide, onHidden, nth]);

	return (
		<div
			ref={domElem}
			style={hide ? { marginTop: hideMargin.current } : undefined}
			className={`messenger-message${(visible || hide) ? ' show' : ''}${(hide) ? ' hide' : ''}`}>
			<button
				onClick={hideElem}
				type="button"
				className={`message-btn type-${message.type}`}>
				{message.text}
			</button>
		</div>
	)
}

export default MessengerDom;